import './index.scss';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './app/App';

// Get our root container then render the App inside BrowserRouter.
const container = document.getElementById('root') as HTMLElement;
const app = (
  <BrowserRouter>
    <App id={'app'} />
  </BrowserRouter>
);
createRoot(container).render(app);
